export default __webpack_public_path__ + "static/media/xd.df4fcf1c.svg";